import type { FaireProductEntity } from "../../entity_types/product";

export const p_eay9k97q29: FaireProductEntity = {
  token: "p_eay9k97q29",
  type: "product",
  name: "Intensive Healing Salve",
  brandToken: "b_rvn46uxywb",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/2a053d781996ac0f0a5a61ab5f6275c107953844c27751387919030e8db87f9a.jpeg",
  galleryImageUrls: [],
  priceDollars: 5.55,
  description:
    "A customer favorite, this all-natural salve can help promote new skin cell regeneration while reducing inflammation and healing skin quickly to minimize scarring. Great for minor cuts, scrapes, rashes or minor burns (without blistering). A bit more intensive than our All Purpose Salve. \n\n1 oz. Tin",
  tags: [],
  msrpDollars: 11.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:30.796Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
